<template>
	<div class="height-100dvh">
		<div class="mob-back-header" @click="goBack">
			<img
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Test Details
		</div>
		<div
			v-if="loaderStatus"
			class="mob-back-body d-flex justify-content-center align-items-center overflow-hidden"
		>
			<Spinner />
		</div>
		<div
			:class="!hasAccess() && 'mob-assess-body top-16px'"
			class="mob-back-body"
			v-else
		>
			<div class="mob-test-details-overflow">
				<template v-if="selectedAssessment.companyName">
					<div class="mob-small-head">Company</div>
					<div class="mb-mobile-txt-2 text-truncate">
						{{ selectedAssessment.companyName }}
					</div>
					<div class="mob-small-head mt-2">Job Title</div>
					<div class="mb-mobile-txt-2 text-break">
						{{ selectedAssessment.jobName || "NA" }}
					</div>
				</template>
				<template v-else>
					<div class="mob-small-head mt-2">Organiser</div>
					<div class="mb-mobile-txt-2 text-truncate">
						{{ selectedAssessment.organiser }}
					</div>
				</template>
				<div class="border-bottom mt-2 mb-2"></div>

				<div class="d-flex mt-2">
					<div class="w-50">
						<div class="mob-small-head d-flex align-items-center">
							<img
								class="mr-1"
								src="../../assets/newdesign/assessPro/smallCalen.svg"
								alt=""
							/>
							Start date :
						</div>
						<div class="mb-mobile-txt-2 mt-1">
							{{ formatTime(selectedAssessment.config?.openTestdt) }},
							{{ formatDate(selectedAssessment.config?.openTestdt) }}
						</div>
					</div>
					<div class="w-50">
						<div class="mob-small-head d-flex align-items-center">
							<img
								class="mr-1"
								src="../../assets/newdesign/assessPro/smallCalen.svg"
								alt=""
							/>
							End date :
						</div>
						<div class="mb-mobile-txt-2 mt-1">
							{{ formatTime(selectedAssessment.config.closeTestdt) }},
							{{ formatDate(selectedAssessment.config.closeTestdt) }}
						</div>
					</div>
				</div>
				<div class="d-flex mt-2">
					<div class="w-50">
						<div class="mob-small-head">Total attempts</div>
						<div class="mb-mobile-txt-2">
							{{ selectedAssessment.config.maxnoattempts }}
						</div>
					</div>
					<div class="w-50" v-if="selectedAssessment.config.timebnvalue">
						<div class="mob-small-head">Time between attempts</div>
						<div class="mb-mobile-txt-2">
							{{ selectedAssessment.config.timebnvalue }}
							{{ selectedAssessment.config.timebnsel }}
						</div>
					</div>
				</div>
				<div class="border-bottom mt-2 mb-2"></div>
				<div class="mob-small-head">Topic Name</div>
				<div class="mb-mobile-txt-2 text-truncate">
					{{ selectedAssessment.topicName }}
				</div>
				<div class="mob-small-head mt-2">Test Name</div>
				<div class="mb-mobile-txt-2 text-truncate">
					{{ selectedAssessment.testName }}
				</div>
				<div
					class="mb-descriptn-txt-1 mt-1"
					v-html="selectedAssessment.config.testDesc"
				></div>
				<div class="border-bottom mt-2 mb-2"></div>
				<div class="mob-blue-card">
					<div class="w-50 d-flex mt-2">
						<div>
							<img src="../../assets/mobile/assprog/totalDuration.svg" alt="" />
						</div>
						<div class="ml-2 pt-1">
							<div class="mob-small-head">Duration</div>
							<div class="mb-mobile-txt">
								{{ selectedAssessment.config.testDuration }}
								Min
							</div>
						</div>
					</div>
					<div
						class="w-50 d-flex mt-2"
						v-if="selectedAssessment.proctoringType"
					>
						<div>
							<img
								v-if="
									selectedAssessment.proctoringType === 'agent-extension-video'
								"
								src="../../assets/mobile/assprog/allProctoring.svg"
								alt=""
							/>
							<img
								v-else-if="selectedAssessment.proctoringType === 'video'"
								src="../../assets/mobile/assprog/video.svg"
								alt=""
							/>
							<img
								v-else-if="selectedAssessment.proctoringType === 'agent'"
								src="../../assets/mobile/assprog/agent.svg"
								alt=""
							/>
							<img
								v-else-if="selectedAssessment.proctoringType === 'extension'"
								src="../../assets/mobile/assprog/extension.svg"
								alt=""
							/>
							<img
								v-else-if="
									selectedAssessment.proctoringType === 'extension-video'
								"
								src="../../assets/mobile/assprog/extensionAndVideo.svg"
								alt=""
							/>

							<img
								v-else-if="selectedAssessment.proctoringType === 'agent-video'"
								src="../../assets/mobile/assprog/agentAndVideo.svg"
								alt=""
							/>
							<img
								v-else
								src="../../assets/mobile/assprog/extensionAndAgent.svg"
								alt=""
							/>
						</div>
						<div class="ml-2 pt-1">
							<div class="mob-small-head">Proctoring</div>
							<div class="mb-mobile-txt">Enabled</div>
						</div>
					</div>
					<div class="w-50 d-flex mt-2">
						<div>
							<img src="../../assets/mobile/assprog/totalQues.svg" alt="" />
						</div>
						<div class="ml-2 pt-1">
							<div class="mob-small-head">Total Questions</div>
							<div class="mb-mobile-txt">
								{{ selectedAssessment.totalQuestionsCount }}
							</div>
						</div>
					</div>
					<div class="w-50 d-flex mt-2">
						<div>
							<img src="../../assets/mobile/assprog/totalSec.svg" alt="" />
						</div>
						<div class="ml-2 pt-1">
							<div class="mob-small-head">Total Sections</div>
							<div class="mb-mobile-txt">
								{{ selectedAssessment.totalSectionsCount }}
							</div>
						</div>
					</div>
					<div class="w-50 d-flex mt-2">
						<div class="">
							<img src="../../assets/mobile/assprog/diffLevel.svg" alt="" />
						</div>
						<div class="ml-2 pt-1">
							<div class="mob-small-head">Difficulty Level</div>
							<div class="mb-mobile-txt">
								{{ selectedAssessment.intDifficulty }}
							</div>
						</div>
					</div>
				</div>
				<div class="position-relative mt-4">
					<hr style="border-top: 1px solid #8c8c8c" class="my-3" />
					<div
						class="fam-lato fs-14 fw-M color-595959 px-2 position-absolute"
						style="left: 40%; top: -12px; background: white"
					>
						Contents
					</div>
				</div>
				<div
					v-for="(section, index) in sectionDetails"
					:key="section.sectionID"
					class="section-card"
					:class="index == 0 ? 'mt-0' : 'mt-3'"
					@click="toggleSection(index)"
				>
					<!-- Header -->
					<div
						class="d-flex justify-content-between align-items-center pointer p-12px"
						v-b-toggle="'section-' + index"
					>
						<div class="fw-LM fs-14 fam-lato text-black">
							{{ section.sectionName }}
						</div>

						<div class="d-flex align-items-center">
							<span class="mr-2"
								><span class="fw-R fam-mont fs-12 color-3a3c40"
									><img
										src="../../assets/icons/totquestions.svg"
										alt=""
										class="mr-1"
									/>Total Questions: </span
								><span class="fw-LM fam-mont fs-12 color-3a3c40">{{
									section.totalQuestions
								}}</span>
							</span>
							<img
								class="ml-2"
								:class="{
									rotateArrow: activeSection !== index,
									rotateddown: activeSection === index,
								}"
								src="@/assets/assessment/filteruparw.svg"
							/>
						</div>
					</div>

					<!-- Collapse -->
					<b-collapse
						:id="'section-' + index"
						accordion="section-accordion"
						class="section-accordion"
					>
						<div class="dashed-divider-td"></div>
						<div class="section-body p-12px">
							<div class="d-flex flex-wrap">
								<div
									v-for="level in section.difficultyBreakdown"
									:key="level.level"
									class="level-item mr-3"
									v-if="level.questions > 0"
								>
									<span class="fs-12">
										<img src="../../assets/assessment/level.svg" alt="" />
										<span class="fw-R">{{ level.level }} : </span>
										<span class="fw-LM">{{ level.questions }}</span>
									</span>
								</div>
							</div>
						</div>
					</b-collapse>
				</div>
			</div>
			<div class="mob-footer w-100 px-3">
				<div class="mob-cancelBtn w-50 pr-2">
					<b-button class="w-100" @click="goBack">Cancel</b-button>
				</div>
				<div
					class="mob-addBtn pl-2"
					:class="
						selectedAssessment.setPricing == true &&
						selectedAssessment.purchased === false
							? ''
							: 'w-50'
					"
				>
					<b-button
						v-if="
							isUpcoming(selectedAssessment) &&
							selectedAssessment.setPricing == false
						"
						class="w-100"
						@click="notifyMe(selectedAssessment)"
						>Notify Me</b-button
					>
					<b-button
						v-else-if="selectedAssessment.attemptsLeft == 0"
						class="w-100"
						@click="goBack"
						>Okay</b-button
					>
					<b-button
						v-else-if="
							selectedAssessment.setPricing == true &&
							selectedAssessment.purchased === false
						"
						class="candash-addBtn"
						@click="
							!hasAccess() ? openLoginModal() : purchaseTest(selectedAssessment)
						"
					>
						₹{{ selectedAssessment.finalPrice }}
						<span class="mx-1">
							<img src="../../assets/icons/line.svg" alt="" />
						</span>
						Buy Now
					</b-button>
					<b-button
						v-else
						class="w-100"
						@click="takeNewTest(selectedAssessment)"
						>Take Test</b-button
					>
					<!-- <b-button
          v-else
          class="w-100"
          @click="openLink(selectedAssessment.shareLink)"
          >{{ selectedAssessment.attemptsLeft }} Attempts Left</b-button
        > -->
				</div>
			</div>
		</div>
		<div style="display: none" ref="responseContainer"></div>
	</div>
</template>

<script>
import {
	getMarks,
	getShareLink,
	getParticularsectionDetails,
	postPurchaseTest,
	getGlobalTrending,
} from "@/utils/apiFunctions";
import payment from "@/components/mixin/payment";
import { trackEvent } from "@/tracking/events";
import { mapGetters } from "vuex";
import { trackSelfAssessPlayed } from '@/utils/posthogHelpers';

import Spinner from "@/components/fixedcomponents/Spinner.vue";
import { hasAccess } from "@/utils/tokenCheck";
import EventBus from "@/utils/EventBus";
export default {
	name: "mobAssessment",
	data() {
		return {
			public: this.$route.query.public,
			from: this.$route.query.home,
			sectionDetails: [],
			loaderStatus: false,
			activeSection: null,
		};
	},
	mixins: [payment],
	// props: {
	// 	showMobileTestDetails: {
	// 		type: Boolean,
	// 		default: false,
	// 	},
	// 	public: Boolean,
	// 	from: String,
	// 	// selectedAssessment: {
	// 	// 	type: Object,
	// 	// 	default: () => ({}),
	// 	// },
	// },
	created() {
		this.getTestDetails();
		this.getTrendingAssessment();
	},

	components: {
		Spinner,
	},
	props: {
		cardType: {
			type: String,
			default: "default", // default, completed, upcoming, ongoing
		},
	},
	methods: {
		openLoginModal() {
			EventBus.$emit("open-login-modal");
		},
		hasAccess() {
			return hasAccess();
		},
		toggleSection(index) {
			this.activeSection = this.activeSection === index ? null : index;
		},
		purchaseTest(assessment) {
			this.loaderStatus = true;
			this.selectedAssessment = assessment;
			this.checkCustomer();
		},
		async postPurchaseTest() {
			if (!this.orderID) return;
			try {
				const reference =
					this.cardType === "completed" ||
					this.cardType === "upcoming" ||
					this.cardType === "ongoing"
						? this.selectedAssessment.referenceID
						: this.selectedAssessment.testID;

				let payload = {
					references: [reference],
					orderID: this.orderID,
					email: this.userInfo.email,
					pricingID: this.selectedAssessment.pricingID,
				};

				const response = await postPurchaseTest(payload);
				console.log("Purchase Test Response:", response);
				// this.$emit("refreshPublicTests");
				// this.assessment.purchased = true;
				this.selectedAssessment.purchased = true;
				this.loaderStatus = false;
				this.successModal("Success", "Test purchased successfully!");
				trackEvent("assessment_purchased", { assessmentID: this.selectedAssessment.testID });
			} catch (error) {
				console.error("Error purchasing test:", error);
			} finally {
				this.loaderStatus = false;
			}
		},
		async getTestDetails() {
			try {
				console.log("Calling API for test:", this.selectedAssessment.testID);

				const res = await getParticularsectionDetails(
					this.selectedAssessment.testID
				);

				if (res.status === 200) {
					this.sectionDetails = res.data.data.sections;
					console.log("Section Details:", this.sectionDetails);
				} else {
					console.error("Failed to fetch section details. Status:", res.status);
				}
			} catch (err) {
				console.error("API error:", err);
			}
		},
		async takeNewTest(assessment) {
			if (hasAccess()) trackEvent("assessment_opened", { assessmentID: assessment.testID });
			const addFromCandidate = (link) => this.appendQuery(link, { key: "from", value: "candidate" });
			if(assessment.shareLink){
				window.open(addFromCandidate(assessment.shareLink), "_blank");
			}else{
				const res = await getShareLink({
					email: this.userInfo?.email || "", // Handle case where vuex might not be ready, though unlikely if logged in
					testID: assessment.testID,
					publicConfigType: assessment.publicConfigType || 0,
				});
				if(res.status === 200 && res.data.data.shareLink){
					window.open(addFromCandidate(res.data.data.shareLink), "_blank");
				}else{
					console.log("Failed to generate assessment link.");
				}
			}
		},
		appendQuery(link, query) {
			// let url = new URL(link);
			// url.searchParams.append(query.key, query.value);
			// return url.href;
			const [baseUrl, fragment] = link.split("#");
			//checking for fragmentation in hire3x url

			if (fragment) {
				const [path, queryString] = fragment.split("?");
				const params = new URLSearchParams(queryString || "");
				params.append(query.key, query.value);

				return `${baseUrl}#${path}?${params.toString()}`;
			} else {
				const url = new URL(link);
				url.searchParams.append(query.key, query.value);

				return url.href;
			}
    	},
		goBack() {
			if (this.from == "home") {
				this.$emit("go-back");
			} else {
				this.$router.go(-1);
			}
		},
		openLink(link) {
			window.open(link, "_blank");
		},
		formatDate(date) {
			return new Date(date)
				.toLocaleString("en-IN", {
					day: "2-digit",
					month: "2-digit",
					year: "numeric",
				})
				.replaceAll("/", "-");
		},
		formatTime(date) {
			return new Date(date).toLocaleString("en-IN", {
				hour: "numeric",
				minute: "numeric",
				hour12: true,
			});
		},
		notifyMe(assessment) {
			this.showNotifyMe = true;
		},
		isUpcoming(assessment) {
			return (
				new Date(assessment.config.openTestdt).getTime() > new Date().getTime()
			);
		},
		viewTestDetails(assessment) {
			this.selectedAssessment = Object.assign({}, assessment);
			this.showTestDetails = true;
			this.currentMobileScreen = MOBILE_TEST_DETAILS;
		},
		async getTrendingAssessment() {
			try {
				let payload = {
					type: "assessment",
					interactionType: "click",
					referenceID: this.selectedAssessment.testID,
				};
				const response = await getGlobalTrending(payload);
			} catch (error) {
				console.log(error);
			}
		},
	},
	computed: {
		paymentItemID() {
			return this.selectedAssessment?.paymentItemID;
		},
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
		...mapGetters("candidateVUEX", {
			selectedAssessment: "getselectedAssessment",
		}),
	},
};
</script>

<style>
.mob-test-details-overflow {
	height: 90%;
	overflow: auto;
	background-color: #ffffff;
	border-radius: 4px;
	padding: 13px 10px;
}
.mob-blue-card {
  background-color: #f6f9fb;
  border-radius: 12px;
  padding: 3px 17px 13px 17px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.section-card {
	background: #ffffff;
	border: 1px solid #efefef;
	border-radius: 8px;
	overflow: hidden;
}
.p-12px {
	padding: 12px;
}
.section-accordion {
	background: #f6f9fb;
}
.dashed-divider-td {
	width: 100%;
	height: 1px;
	background-image: repeating-linear-gradient(
		to right,
		#d1d5db 0px,
		#d1d5db 8px,
		transparent 8px,
		transparent 10px
	);
}
</style>
